import { api } from "../../common/config/api";

export const CLIENT_URL = {
   getClients: `${api.withAPI}/v1/customer/search`,
   getClient: `${api.withAPI}/v1/customer`,
   editClient: `${api.withAPI}/v1/customer`,
   removeClient: `${api.withAPI}/v1/customer`
}
